import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrl: './button.component.scss'
})
export class ButtonComponent {

  //Type Value; submit, button
  @Input() type: string;

  //Class Value; bootstap button class
  @Input() class: string;

  @Input() label: string;

  @Input() click: string;

  @Output() clickOn = new EventEmitter<any>();

  onClickbutton(event:any) {
    this.clickOn.emit(event);
  }
}
